// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"31b57a7b","499":"6351a5df","783":"a8a1fd4f"}[chunkId] + ".chunk.css";
};